import { render, staticRenderFns } from "./FeeTable.vue?vue&type=template&id=01669dec&"
import script from "./FeeTable.vue?vue&type=script&lang=ts&"
export * from "./FeeTable.vue?vue&type=script&lang=ts&"
import style0 from "./FeeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FeeTable.vue"
export default component.exports